import type React from "react";

import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { getReportQuestionTitle } from "routes/patients/PatientProfile/components/Information/components/HealthReports/utils/getReportQuestionTitle";

import type { PainLocation, Question } from "../../helpers";

import { QuestionCellContainer } from "./styles";

interface QuestionCellProps {
  isSubQuestion?: boolean;
  question: Question;
  rowIndex?: number;
  painLocation?: PainLocation;
}

export const QuestionCell: React.FC<QuestionCellProps> = ({
  isSubQuestion = false,
  question,
  rowIndex,
  painLocation,
}) => {
  const { t } = useTranslation();

  const isVasScale = question.key === "overall_health_vas" || question.key === "feeling_last_days";
  const minScale = isVasScale ? t("patients.health_reports.vas_min") : t("patients.health_reports.low");
  const maxScale = isVasScale ? t("patients.health_reports.vas_max") : t("patients.health_reports.high");

  return (
    <QuestionCellContainer
      isSubQuestion={isSubQuestion}
      rowIndex={rowIndex}
      data-testid={`question-cell-${question.key}`}
    >
      <Typography>{getReportQuestionTitle(question, t, painLocation)}</Typography>
      {question.subtitle && (
        <Typography variant="body_thin" mt={0.5}>
          {/* FIXME: type translation */}
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          {t(`patients.health_reports.questions_content.${question.subtitle}`)}
        </Typography>
      )}
      {question.description && (
        <>
          <Typography variant="body_thin" mt={0.5}>
            {/* FIXME: type translation */}
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            {`${minScale}: ${t(`patients.health_reports.questions_content.${question.description[0]}`)}`}
          </Typography>
          <Typography variant="body_thin" mt={0.5}>
            {/* FIXME: type translation */}
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            {`${maxScale}: ${t(`patients.health_reports.questions_content.${question.description[1]}`)}`}
          </Typography>
        </>
      )}
    </QuestionCellContainer>
  );
};
